import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TodoService } from '../todo.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalUserService } from 'app/main/shared/services/localUser';
import * as moment from 'moment';
import { Title } from '@angular/platform-browser';
import { EguardConfirmatialogComponent } from 'app/core/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'todo-side-nav',
  templateUrl: './todo-side-nav.component.html',
  styleUrls: ['./todo-side-nav.component.scss']
})
export class TodoSideNavComponent implements OnInit {

  @Input() task: any;
  @Input() project: any;
  @Output()
  upDateList: EventEmitter<any> = new EventEmitter();

  @Output()
  remove: EventEmitter<any> = new EventEmitter();

  selectedAccount: string;
  days;
  userRole;

  stepName: string;
  value: string;

  progress = true;
  priority: string;
  date: Date;
  userId: string;
  data: any;

  isEditable: boolean

  currentDate: Date;
  dialogRef: any;
  orgId: string;
  users: string[] = []
  constructor(
    private todoService: TodoService,
    private activatedRoute: ActivatedRoute,
    public _router: Router,
    private localUser: LocalUserService,
    public dialog: MatDialog,
  ) {
    this.selectedAccount = 'creapond';

    this.days = [
      { id: 1, name: 'Today', value: 'Today' },
      { id: 2, name: 'Week', value: 'Weekly' },
      { id: 3, name: 'Month', value: 'Monthly' }
    ];

    this.userRole = this.localUser.getRole();
    this.userId = this.localUser.getUserId();
    this.orgId = this.localUser.getOrganizationId();
  }
  ngOnInit() {
    // this.orgId = this.localUser.getOrganizationId();
  }
  selectedList($event) {
    this.users = $event.map(item => item.id);
  }
  assign() {
    this.progress = true;
    let model = {
      user_ids: this.users
    }
    this.todoService.assign(this.userId, this.project.id, this.task.id, model)
      .subscribe(task => {
        this.upDateList.emit();
        this.progress = false;
      })
  }
  removeAssign() {
    this.progress = true;
    let model = {
      user_ids: this.userId
    }
    this.todoService.removeAssign(this.userId, this.project.id, this.project.task.id, model)
      .subscribe(task => {
        this.progress = false;
      })
  }

  toTitleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  updateTask(task) {
    this.progress = true;
    this.todoService
      .updateTask(this.userId, task.list_id, task.id, this.task)
      .subscribe(data => {
        this.upDateList.emit();
        this.progress = false;
      });

    event.stopPropagation();
  }


  getNextPriority(value) {
    if (value == 'LOW') {
      return 'MEDIUM'
    } else if (value == 'MEDIUM') {
      return 'HIGH'
    } else if (value = 'HIGH') {
      return 'LOW'
    }
  }

  addSteps(stepTitle) {
    this.progress = true;
    let steps = {
      title: stepTitle
    }
    this.todoService.addTasksSteps(this.userId, this.task.list_id, this.task.id, steps)
      .subscribe(item => {
        // this.task.steps = [];
        this.task = item
        this.stepName = null;
        this.upDateList.emit(this.task);
        this.progress = false;
      })
  }
  updateSteps(step) {
    this.progress = true;
    let model = {
      id: step.id,
      title: step.title,
      is_completed: step.is_completed
    }
    this.todoService.updateSteps(this.userId, this.task.list_id, this.task.id, step.id, model)
      .subscribe(item => {
        this.upDateList.emit(this.task);
        this.progress = false;
      })
  }

  deleteSteps(steps) {
    this.progress = true;
    this.todoService.deleteSteps(this.userId, this.task.list_id, this.task.id, steps.id)
      .subscribe(item => {
        this.task = item
        this.upDateList.emit(this.task);
        this.progress = false;
      })
  }

  // changePriority(task) {
  //   task.priority = this.getNextPriority(task.priority)

  //   this.updateTask(task)
  // }

  deleteConfirmationSteps(steps) {
    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Are you sure want to delete this Step?'
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.deleteSteps(steps);
        }
      });
  }


  addMyDay(task) {
    task.my_day = new Date();
    this.updateTask(task)
  }

  removeMyDay(task) {
    task.my_day = null;
    this.updateTask(task);
  }
  removeDueDate(task) {
    task.due_date = null;
    this.updateTask(task);
  }
  setColor(task) {
    this.currentDate = new Date()
    let dueDate = new Date(task.due_date)
    if (moment(dueDate).startOf('day') < moment(this.currentDate).startOf('day')) {
      return 'red';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-side-nav/todo-side-nav.component.ts